import axios from 'axios';
import {BASE_URL} from '../utils/Constant';

export function submitForm(url, data) {
  return axios
    .post(BASE_URL + url, data)
    .then((r) => r.data);
}
